import type { ChangeEvent, FocusEvent } from 'react';
import type { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

type Format = { on: 'change' | 'blur'; apply: (v: string) => string };

/**
 * Registra um campo de texto com formatação: `change` reescreve enquanto se
 * digita (minutos), `blur` arruma ao sair (espaços, tags).
 */
export function formatted<T extends FieldValues>(form: UseFormReturn<T>, name: FieldPath<T>, fmt: Format) {
  const reg = form.register(name);
  const set = (v: string) =>
    form.setValue(name, fmt.apply(v) as never, { shouldDirty: true, shouldValidate: true });
  return {
    ...reg,
    onChange:
      fmt.on === 'change'
        ? async (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => set(e.target.value)
        : reg.onChange,
    onBlur: async (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (fmt.on === 'blur') set(e.target.value);
      await reg.onBlur(e);
    },
  };
}
